/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { array, lazy, object, Schema } from '../schema';
import { StandingOrder, standingOrderSchema } from './standingOrder';

export interface Data9 {
  standingOrder: StandingOrder[];
}

export const data9Schema: Schema<Data9> = object({
  standingOrder: ['StandingOrder', array(lazy(() => standingOrderSchema))],
});
